export default "__VITE_ASSET__de76959f__"